// CustomTooltip.js - Reusable tooltip component for Recharts
import React from 'react';

const getChartColorToken = (color) => (color || "").replace("#", "").toLowerCase();

export const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="oct_recharts-tooltip-v2">
                {label && (
                    <p className="tooltip-label-v2">{label}</p>
                )}
                {payload.map((entry, index) => {
                    if (entry.payload && entry.payload.isEmptyState) {
                        return (
                            <div key={`item-${index}`} className="tooltip-item-v2 tooltip-item-v2--centered">
                                <span>{entry.name}</span>
                            </div>
                        );
                    }
                    return (
                        <div key={`item-${index}`} className="tooltip-item-v2">
                            <div
                                className="tooltip-color-box-v2"
                                data-chart-color={getChartColorToken(entry.color)}
                            />
                            <span>{entry.name}: {entry.value}</span>
                        </div>
                    );
                })}
            </div>
        );
    }
    return null;
};
